import BaseModel from "./BaseModel";
import CommentVisibility from "./Enums/CommentVisibility";
import Comment from "./Comment";
import { writable } from "svelte/store";

class CommentThread extends BaseModel {
	constructor(data) {
		super({}, CommentThread.defaults);
		this.data = data;
		// this.type = "CommentThread";
		this.data.first_comment = new Comment(this.data.first_comment, this);
		this.data.last_comment = new Comment(this.data.last_comment, this);

		this._comments = [];

		this.lastUpdated = writable(Date.now());
	}

	isNew() {
		return (typeof this.id === "undefined") || this.id === -1;
	}

	removeAllComments() {
		for (let i = 0; i < this._comments.length; i++) {
			this._comments[i].thread = null;
		}
		this._comments = [];
		this.data.first_comment = CommentThread.defaults.first_comment;
		this.data.first_comment.thread = this;
		this.data.last_comment = CommentThread.defaults.last_comment;
		this.data.last_comment.thread = this;
		this.data.comment_count = 0;
		this.lastUpdated.set(Date.now());
	}

	// _onCommentsChanged() {	}

	removeCommentById(id) {
		let removed = false;
		for (let i = 0; i < this._comments.length; i++) {
			const c = this._comments[i];
			if (c.id === id) {
				c.thread = null;
				this._comments.splice(i, 1);
				removed = true;
				break;
			}
		}
		if (removed) {
			this.data.comment_count--;
		}
	}

	addComment(comment) {
		comment.thread = this;

		this._comments.push(comment);

		this.data.comment_count += 1;
		// TODO: update user count?

		this.data.first_comment = this._comments[0];
		this.data.last_comment = this._comments[this._comments.length - 1];

		this.lastUpdated.set(Date.now());
	}

	setVisibility(visibility) {
		this.data.visibility = visibility;
		this.lastUpdated.set(Date.now());
	}

	setLocked(locked) {
		this.data.locked = locked;
		this.lastUpdated.set(Date.now());
	}

	setRemoved(removed) {
		this.data.removed = removed;
		this.lastUpdated.set(Date.now());
	}

	get id() {
		return this.get("id");
	}

	get title() {
		return this.get("title");
	}

	get readableTitle() {
		return (this.title.length > 0)
			? this.title
			: "No Title";
	}

	get firstComment() {
		return this.get("first_comment");
	}

	get lastComment() {
		return this.get("last_comment");
	}

	get comments() {
		return this._comments;
	}

	get userCount() {
		return this.get("user_count");
	}

	get commentCount() {
		return this.get("comment_count");
	}

	get attachmentCount() {
		return this.get("attachment_count");
	}

	get locked() {
		return this.get("locked");
	}

	get removed() {
		return this.get("removed");
	}

	get visibility() {
		return this.get("visibility");
	}

	get visibilityName() {
		return CommentVisibility.toName(this.visibility);
	}

	get visibilityDescription() {
		return CommentVisibility.toDescription(this.visibility);
	}

	get userId() {
		return this.get("user_id");
	}

	get companyId() {
		return this.get("company_id");
	}

	update(data) {
		super.setData(data);
	}
}
CommentThread.defaults = { // Defaults
	id: -1,
	company_id: -1,
	user_id: -1,
	title: "",
	visibility: CommentVisibility.PRIVATE,
	first_comment: new Comment(),
	last_comment: new Comment(),
	user_count: 0,
	comment_count: 0,
	attachment_count: 0,
	locked: 0,
	removed: 0
};

export default CommentThread;
